import { render } from "./SwitchLang.vue?vue&type=template&id=2f0bc85e&scoped=true"
import script from "./SwitchLang.vue?vue&type=script&lang=js"
export * from "./SwitchLang.vue?vue&type=script&lang=js"

import "./SwitchLang.vue?vue&type=style&index=0&id=2f0bc85e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0bc85e"]])

export default __exports__